export default "__VITE_ASSET__C5yQeCqx__"